var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideshow__container",class:{ hidePagination: _vm.totalNumberOfItems <= 1 }},[_c('b-carousel',{attrs:{"id":"carousel-fade","interval":5000,"controls":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }